import dayjs from 'dayjs';

function isBefore(isBefore: string): boolean {
  if (!isBefore) {
    return false;
  }

  const isBeforeValue = dayjs(new Date()).isBefore(isBefore, 'day');
  return isBeforeValue;
}

export default isBefore;
